import { remoteNone, RemoteResource } from 'sdi/source';
import { Collection, Nullable } from 'sdi/util';
import {
    Issue,
    IssueType,
    OsmObject,
    OsmElementNode,
    OsmElementWay,
    OsmElementRelation,
    LinkedIssues,
    TagForm,
    EvaluationList,
    IssueNote,
    GlobalNote,
    OsmUser,
    IssueCriticality,
    CurrentOsmUser,
    IssueGeometryCollection,
    ExternalIssue,
    Theme,
} from '../remote';
import { OsmDownloadState } from '../events/osm';
import { MapillaryImageGroup } from '../remote/mapillary';
import { GlobalFilter } from '../events/qa';

declare module 'sdi/shape' {
    export interface IShape {
        'qa/data/issues': RemoteResource<Issue[]>;
        'qa/data/issue-types': RemoteResource<IssueType[]>;
        'qa/data/evaluations': RemoteResource<EvaluationList[]>;
        'qa/data/notes/issue': RemoteResource<IssueNote[]>;
        'qa/data/notes/global': RemoteResource<GlobalNote[]>;
        'qa/data/issue/user': RemoteResource<OsmUser>;
        'qa/data/osm/user': RemoteResource<CurrentOsmUser>;
        'qa/data/mapillary/images': Collection<
            RemoteResource<MapillaryImageGroup>
        >;
        'qa/data/external-issue': RemoteResource<ExternalIssue>;
        'qa/data/themes': RemoteResource<Theme[]>;

        'qa/issues/select/osm-object': Collection<RemoteResource<OsmObject>>;
        'qa/issues/select': number[];
        'qa/issues/linked/remote': Collection<RemoteResource<number[]>>;
        'qa/issues/linked': LinkedIssues[];
        'qa/issues/linked/selected': Nullable<LinkedIssues>;

        'qa/notes/form': Nullable<string>;
        'qa/contact/form': Nullable<string>;
        'qa/issues/filter/global': GlobalFilter;
        'qa/issues/filter/criticality': Nullable<IssueCriticality>;

        'qa/osm/tags': Nullable<TagForm>;
        'qa/osm/nodes': Collection<OsmElementNode[]>;
        'qa/osm/ways': Collection<OsmElementWay[]>;
        'qa/osm/relations': Collection<OsmElementRelation[]>;
        'qa/osm/remote-state': Collection<OsmDownloadState>;
        'qa/issue/geometries/collection': Collection<IssueGeometryCollection>;
    }
}

export const defaultQaShape = () => ({
    'qa/data/issues': remoteNone,
    'qa/data/issue-types': remoteNone,
    'qa/data/evaluations': remoteNone,
    'qa/data/notes/issue': remoteNone,
    'qa/data/notes/global': remoteNone,
    'qa/data/issue/user': remoteNone,
    'qa/data/osm/user': remoteNone,
    'qa/data/mapillary/images': {},
    'qa/data/external-issue': remoteNone,
    'qa/data/themes': remoteNone,

    'qa/issues/select/osm-object': {},
    'qa/issues/select': [],

    'qa/issues/linked/remote': {},
    'qa/issues/linked': [],
    'qa/issues/linked/selected': null,

    'qa/notes/form': null,
    'qa/contact/form': null,
    'qa/issues/filter/global': 'newOrStalled' as GlobalFilter,
    'qa/issues/filter/criticality': null,

    'qa/osm/tags': null,
    'qa/osm/nodes': {},
    'qa/osm/ways': {},
    'qa/osm/relations': {},
    'qa/osm/remote-state': {},
    'qa/issue/geometries/collection': {},
});
